import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'none_above_facility_meeting_measures_listed_above_regarding_22'

export const dataPointDefinition = {
  retracedId: 'none_above_facility_meeting_measures_listed_above_regarding_22',
  name: 'None of the above - the facility is meeting all measures listed above regarding forklift safety',
  description:
    'Select "X" if the facility HAS all the safety measures in place related to forklifts (and other types of lifting equipment) described above.',
  meta: {
    slcpMeta: {
      key: 'hs-mat-26x',
      number: 'HS-MAT-6-8',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-mat-18',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-38,Yes',
      machineShowHide: '[2],hs-38,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-mat-26x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31560,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
